import { render, staticRenderFns } from "./BusinessDomain.vue?vue&type=template&id=3592e144&lang=pug"
import script from "./BusinessDomain.vue?vue&type=script&lang=js"
export * from "./BusinessDomain.vue?vue&type=script&lang=js"
import style0 from "./BusinessDomain.vue?vue&type=style&index=0&id=3592e144&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3592e144')) {
      api.createRecord('3592e144', component.options)
    } else {
      api.reload('3592e144', component.options)
    }
    module.hot.accept("./BusinessDomain.vue?vue&type=template&id=3592e144&lang=pug", function () {
      api.rerender('3592e144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BusinessDomain.vue"
export default component.exports